import { ENV } from "../../../../src/app/interfaces/interfaces";

export const environment:ENV = {
    production: true,
    apiUrl: 'https://rediperu.organizations.prod.redilatam.com/api/', //Prod
    apiUrlGateway: 'https://rediperu.gateway.prod.redilatam.com/', //Gateway prod
    ticketsUrl: 'http://localhost:61481/', //para dirigir al modulo de tickets
    //urlTes:'https://madness.vouchers.prod.todotix.net/api/report-reservation-by-auth?event_id=&excel=true'
    linkUrl: 'https://rediperu.payments.prod.redilatam.com/', //Prod
    bridgeUrl: 'https://bridge.prod.redilatam.com/', //bridge test
    // currency: 'Bs', // bolivia
    currency: 'S/', // peru
    //currency: 'COP', // colombia
    tenantId: 'rediperu',
    type: 'redi',
    title: 'Redi',
    subtitle: 'Membresías',
    description: `"Vias GAMC" es un sitio en el que puedes administrar tus membresías, como las de socios, entradas y abonos.`,
    keywords: 'Vias GAMC, membresias, socios, abonos, entradas, tickets',
    yearProyect: '2025',
    imgLogoIcon: '/assets/img/logo-redi-black.png',
    imgLogoIconWhite: '/assets/img/isotipo-white.svg',
    imgLogo: '/assets/img/logo-redi.png',
    imgLogoSVG: '/assets/img/logo-redi.png',
    imgLogoWhiteSVG: '/assets/img/logo-redi.png',
    imgLogoWhite: '/assets/img/logo-redi.png',

    templateType: 'template-2',
    theme: 'light',
    changeTheme: false,

    authGoogle: false,
    authFacebook: false,
    authApple: false,
    authGithub: false,

    authRedirect: '/home',

    loaderType: 1,
    loaderDefaultText: 'Cargando...',

    //* Firebase
    firebase: {},

    keyEncript: '12345678901234567890123456789012',
    ivEncript: '1234567890123456',


    // bridgeKeys
    x_api_key: '17bb7ba9-d405-48f8-8227-819a27286d2a',
    x_secret_key: '74486e5c-554d-4250-8383-763248865b10',
};
